<panel width="300" draggable="h1">
  <h1>Test 1</h1>
  hej
</panel>
<panel draggable="h1">
  <h1>Test 2</h1>
  <h3>Aftaleperioder</h3>
  <list-view >
    <header defaultSort="ascending">Plan id.</header>
    <header>Start</header>
    <header>Slut</header>
    <header>{{ 'ledger-posts.column.postedDate' | translate }}</header>
    <header>{{ 'ledger-posts.column.overdue' | translate }}</header>
    <header>{{ 'ledger-posts.column.open' | translate }}</header>
    <header align-right>{{ 'ledger-posts.column.value' | translate }}</header>

    <row *listData="let post from posts">
      <column>hej</column>
      <column>hej</column>
      <column>hej</column>
      <column>hej</column>
      <column>hej</column>
      <column>hej</column>
      <column>hej</column>
    </row>
  </list-view>
</panel>
<panel width="300">
  <h1>Soft-popup</h1>
  <section>
    <icon type="circle-info" [trigger-soft-popup]="pop1" />
    <soft-popup #pop1>
      <section one-column>
        Jeg er triggerd med et click event
      </section>
      <section>
        <text-group>
          <span>Pris: </span>
          <span align-right>110.000,00</span>

          <span>Modregning: </span>
          <span align-right>-10.500,00</span>

          <span bold>Samlet pris: </span>
          <span align-right bold>90.500,00</span>
        </text-group>
      </section>
    </soft-popup>
  </section>
  <section>
    <icon type="circle-info" [trigger-soft-popup]="pop2" />
    <soft-popup #pop2 [width]="1500">
      <section one-column>
        Jeg er bred og triggerd med et click event
      </section>
    </soft-popup>
  </section>
  <section>
    <icon type="circle-info" [trigger-soft-popup]="pop3" />
    <soft-popup #pop3>
      <section one-column>
        Jeg er høj og triggerd med et click event
      </section>
      <section>
        <text-group>
          <span>Pris: </span>
          <span align-right>110.000,00</span>

          <span>Modregning: </span>
          <span align-right>-10.500,00</span>

          <span bold>Samlet pris: </span>
          <span align-right bold>90.500,00</span>
        </text-group>
      </section>
      <section>
        <text-group>
          <span>Pris: </span>
          <span align-right>110.000,00</span>

          <span>Modregning: </span>
          <span align-right>-10.500,00</span>

          <span bold>Samlet pris: </span>
          <span align-right bold>90.500,00</span>
        </text-group>
      </section>
      <section>
        <text-group>
          <span>Pris: </span>
          <span align-right>110.000,00</span>

          <span>Modregning: </span>
          <span align-right>-10.500,00</span>

          <span bold>Samlet pris: </span>
          <span align-right bold>90.500,00</span>
        </text-group>
      </section>
      <section>
        <text-group>
          <span>Pris: </span>
          <span align-right>110.000,00</span>

          <span>Modregning: </span>
          <span align-right>-10.500,00</span>

          <span bold>Samlet pris: </span>
          <span align-right bold>90.500,00</span>
        </text-group>
      </section>
    </soft-popup>
  </section>

  <soft-popup [showPopup]="codeTriggeredPopup" [width]="150" [top]="550" [left]="1000">
    <section one-column>
      Jeg er triggerd med kode, ikke et click event
    </section>
  </soft-popup>

</panel>
<panel width="300">
  <h1>Icons</h1>
  <section>
    <div>
      <icon small />&nbsp;&nbsp;
      <icon />&nbsp;&nbsp;
      <icon type="circle-user" small />&nbsp;&nbsp;
      <icon type="circle-user" />
    </div>
  </section>
  <section>
    <div>
      <icon type="circle-user" small badge="1" />&nbsp;&nbsp;
      <icon type="circle-user" badge="1" />&nbsp;&nbsp;
      <icon type="circle-user" small badge="99" />&nbsp;&nbsp;
      <icon type="circle-user" badge="99" />
    </div>
  </section>
  <section>
    <div>
      <icon type="circle-user" small badge="1" bottom center />&nbsp;&nbsp;
      <icon type="circle-user" badge="1" bottom center />&nbsp;&nbsp;
      <icon type="circle-user" small badge="99" bottom center />&nbsp;&nbsp;
      <icon type="circle-user" badge="99" bottom center />
    </div>
  </section>
  <section>
    <div>
      <icon type="circle-user" badge="1" bottom />&nbsp;&nbsp;
      <icon type="circle-user" badge="1" center />&nbsp;&nbsp;
      <icon type="circle-user" badge="99" bottom />&nbsp;&nbsp;
      <icon type="circle-user" badge="99" center />
    </div>
  </section>
  <section>
    <div>
      <icon type="circle-user" attention small badge="1" />&nbsp;&nbsp;
      <icon type="circle-user" attention badge="1" />&nbsp;&nbsp;
      <icon type="circle-user" attention small badge="99" />&nbsp;&nbsp;
      <icon type="circle-user" attention badge="99" />
    </div>
  </section>
  <section>
    <div>
      <icon type="circle-user" info small badge="1" />&nbsp;&nbsp;
      <icon type="circle-user" info badge="1" />&nbsp;&nbsp;
      <icon type="circle-user" info small badge="99" />&nbsp;&nbsp;
      <icon type="circle-user" info badge="99" />
    </div>
  </section>
  <section>
    <icon type="circle-user" />
    <h2>Prefix icon</h2>
    <div>It's so easy!</div>
  </section>
  <section>
    <icon type="circle-user" badge="1" badge-bottom-center />
    <h2>Prefix icon <icon small /></h2>
    <div>It's so easy!</div>
  </section>
  <section>
    <div>
      <icon type="circle-user" (click)="test('1');" />&nbsp;&nbsp;
      <icon type="circle-user" (click)="test('2');" class="disabled" />&nbsp;&nbsp;
      <icon type="circle-user" (click)="test('3');" badge="99" />&nbsp;&nbsp;
      <icon type="circle-user" (click)="test('4');" badge="99" attention />
    </div>
  </section>
</panel>
<panel width="300">
  <h1>Summary</h1>
  <section one-column>
    <summary label="Aftale pris">{{23584 | currency}}</summary>
    <summary label="Månedens medarbejder">{{'Allan Blad'}}</summary>
    <summary label="Valgt dato">{{'2021-03-25' | customDate: 'shortDate'}}</summary>
  </section>
</panel>
@if (false) {
  <debug-input-fields />
}
